import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67320475"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "button-root" }
const _hoisted_2 = { id: "top-open" }

import { onMounted, ref, computed, type CSSProperties, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import Vrouter from '@/router';
// import { toast } from 'vue3-toastify';
// import 'vue3-toastify/dist/index.css';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import PageParamsUtil from '../../utils/PageParamsUtil';
import OpenWpsBridge from '../bridge/OpenWpsBridge';
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import OpenAppButton from './OpenAppButton.vue';
import AppLinkStat from '../stats/AppLinkStat';
import UnsupportOpenPage from './UnsupportOpenPage.vue';
import TemplateRequest from '../data/TemplateRequest';
import { OpenButtonStyle } from './OpenAppButton.vue';
import { ButtonPosition } from '../data/TemplateData';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonOpenButton',
  setup(__props) {

const show_tip = ref(false);
const { t } = useI18n();
const btn_text = ref(t('common.openWpsExperience'));

const openBtn = ref();

const topOpenStyleObj = reactive<OpenButtonStyle>({
  background: '#3B64FC',
  'border-radius': '8px',
  'border-width': '0px',
  width: '280px',
  height: '48px',
  'font-size': '16px',
  color: '#fff',
  'text-decoration-line': 'none',
});

const buttonLayoutStyleObj = reactive({
  height: 'auto',
  'margin-top': '0px',
  'margin-bottom': '0px',
});

const buttonLayoutStyle = computed(() => {
  return {
    ...buttonLayoutStyleObj,
  } as CSSProperties;
});

const viewKey = ref<string>('');

onMounted(() => {
  viewKey.value = AbilityParamsUtil.getViewKey();
  var buttonData = TemplateRequest.getButtonDataByKey(viewKey.value);
  btn_text.value = buttonData.content || t('common.openWpsExperience');
  topOpenStyleObj['background'] = buttonData.bg_color;
  topOpenStyleObj.color = buttonData.text_color;
  topOpenStyleObj.width = buttonData.width;
  topOpenStyleObj.height = buttonData.height;
  topOpenStyleObj['border-radius'] = buttonData.radius;
  topOpenStyleObj['font-size'] = buttonData.text_size;
  if (buttonData.position == ButtonPosition.TOP) {
    buttonLayoutStyleObj['margin-top'] = buttonData.offset;
  } else if (buttonData.position == ButtonPosition.BOTTOM) {
    buttonLayoutStyleObj['margin-top'] = 'auto';
    buttonLayoutStyleObj['margin-bottom'] = buttonData.offset;
  } else {
    buttonLayoutStyleObj['margin-top'] = 'auto';
    buttonLayoutStyleObj['margin-bottom'] = 'auto';
  }

  if (!DeviceEnvUtil.isUnsupportOpen() && AbilityParamsUtil.isAutowWakeup()) {
    setTimeout(() => {
      OpenWpsBridge.openWps();
    }, 200);
  }
});

function dismiss() {
  show_tip.value = false;
}

// function proxyOpen() {
//   openBtn.value.$.vnode.el?.click();
// }

function open() {
  if (DeviceEnvUtil.isUnsupportOpen()) {
    show_tip.value = true;
  } else {
    show_tip.value = false;
    try {
      OpenWpsBridge.openWps();
    } catch (error) {
      console.log('openWps error: ', error);
    }
    autoJumpDownload();
  }
  AppLinkStat.eventAbilityCommonOpenClick(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
    `${show_tip.value}`,
  );
}

function commonOpen() {
  open();
  // if (AbilityParamsUtil.isSupportFunctionOnCurrentPlatform()) {
  //   open();
  // } else {
  //   toast(AbilityParamsUtil.getFunctionBtnTips(), {
  //     autoClose: 1000,
  //   });
  // }
}

function onWeiXinLaunch() {
  AppLinkStat.eventAbilityWeixinOpenClick(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
  );
}

function onWeixinLaunchFail() {
  autoJumpDownload();
}

function autoJumpDownload() {
  setTimeout(() => {
    Vrouter.push({
      path: '/mobile_avocado_ck/download',
      query: {
        chan: AbilityParamsUtil.getDownloadChan(),
        autoJump: AbilityParamsUtil.isAutoJumpDownload() ? '1' : '0',
        ability: AbilityParamsUtil.getAbilityName(),
        _business_id: AbilityParamsUtil.getAbilityBusinessId(),
      },
    });
  }, 1000);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "button-layout",
      style: _normalizeStyle(buttonLayoutStyle.value)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(OpenAppButton, {
          ref_key: "openBtn",
          ref: openBtn,
          onCommonOpen: commonOpen,
          onOnWeixinLaunch: onWeiXinLaunch,
          onOnWeixinLaunchFail: onWeixinLaunchFail,
          openBtnText: btn_text.value,
          openBtnStyleObj: topOpenStyleObj
        }, null, 8, ["openBtnText", "openBtnStyleObj"])
      ])
    ], 4),
    _createVNode(UnsupportOpenPage, {
      show_tip: show_tip.value,
      onDimiss: dismiss
    }, null, 8, ["show_tip"])
  ]))
}
}

})